import { Loyalty } from '@cp-mx/common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchLoyalty } from './LoyaltyNotificationSlice';
import { LoyaltySelector } from './LoyaltyNotificationSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export function useLoyalty(): AbstractDataState<Loyalty[], DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchLoyalty, LoyaltySelector);
}
